import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { register } from 'swiper/element/bundle';

if (environment.production) {
	window.console.log = () => {};
	enableProdMode();
}

register();

document.addEventListener('DOMContentLoaded', () => {
	platformBrowserDynamic()
		.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
		.catch(err => console.error(err));
});
